// extracted by mini-css-extract-plugin
export var container = "styles-module--container--92cqE";
export var content = "styles-module--content--Pbdeh";
export var heading = "styles-module--heading--JzKvn";
export var text = "styles-module--text--iwffV";
export var tiles = "styles-module--tiles--KZ7tD";